import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { Grid } from '@mui/material';
import { AiFillDownCircle } from 'react-icons/ai';
import { AccordionSummary } from '../../../../../../components/expandable-accordion/accordion-summary';
import { AccordionDetails } from '../../../../../../components/expandable-accordion/accordion-details';
import { Accordion } from '../../../../../../components/expandable-accordion/accordion-style';
import { titleData } from '../../utils/constants';
import '../../../pricing-simulator/components/list-price-simulation-table/list-price-simulation.scss';
import PotentialRiskTableComponent from './potential-risk-table';
import { getPotentialRiskData } from '../../store/simulation-summary-slice';

export default function PotentialRiskTableContainerComponent({
  sourceId,
  moduleId,
  scenarioId,
  disableInputs = false,
  mode = 'summary',
}: {
  sourceId: number;
  moduleId: number;
  scenarioId: number;
  // eslint-disable-next-line react/require-default-props
  disableInputs?: boolean;
  mode?: 'summary' | 'comparison';
}) {
  const appDispatch = useAppDispatch();
  const [expandedPanel, setExpandedPanel] = useState<string | false>('panel1');

  /**
   * Handler for accordion click.
   * It will set the value of "expandable accordion" to close & open the accordion
   */
  const handleOnChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpandedPanel(newExpanded ? panel : false);
    };
  const isTargetEnabled = useAppSelector((state) => state.scenarioComparison.isTargetEnabled);
  const currencyFlag = mode === 'comparison' ? isTargetEnabled : undefined;
  useEffect(() => {
    // upsides api call on load
    if (sourceId && moduleId && scenarioId) {
      const upsidesPayload = {
        filter_inputs: [],
        inputs: {},
        ...(mode === 'comparison'
          && { currency_toggle: isTargetEnabled })
      };
      appDispatch(
        getPotentialRiskData({
          dataInput: upsidesPayload,
          sourceId,
          moduleId,
          scenarioId
        })
      );
    }
  }, [moduleId, currencyFlag]);

  return (
    <Accordion
      expanded={expandedPanel === 'panel1'}
      onChange={handleOnChange('panel1')}
    >
      <Grid container my={1} sx={{ paddingTop: '0px', width: '100%' }}>
        <Grid
          item
          xs={3}
          className='container-title-summary'
          sx={{ paddingTop: '0px !important' }}
        >
          <AccordionSummary
            expandIcon={<AiFillDownCircle color='#0000a0' />}
            aria-controls='panel1d-content'
            id='panel1d-header'
          >
            {titleData.potentialUpsidesRisks}
          </AccordionSummary>
        </Grid>
        <Grid
          item
          xs={9}
          sx={{ textAlign: 'right', paddingTop: '10px', paddingRight: '10px' }}
        >
          {/* <Button
            style={{ marginLeft: '15px' }}
            variant='outlined'
            onClick={handleOnClick}
          >
            Download
            <FileDownloadIcon
              style={{ fontSize: '14px', marginLeft: '5px' }}
            />
          </Button> */}
        </Grid>
      </Grid>
      <AccordionDetails style={{ padding: '0px' }}>
        <PotentialRiskTableComponent
          sourceId={sourceId}
          moduleId={moduleId}
          scenarioId={scenarioId}
          disableInputs={disableInputs}
        />
      </AccordionDetails>
    </Accordion>
  );
}
